<script setup>
import { computed } from "vue";

const props = defineProps({
  name: { type: String, required: true },
});

function getFilename(path) {
  return path
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");
}

const modules = import.meta.glob("../assets/svgs/*.svg", { eager: true });
const iconMap = new Map();

Object.entries(modules).forEach(([path, module]) => {
  iconMap.set(getFilename(path), module);
});

const Icon = computed(() => {
  return iconMap.get(props.name);
});
</script>

<template>
  <component :is="Icon" aria-hidden="true" />
</template>
